import { callApi } from "@src/utils/api-client";
import ClientLogsService from "./client-logs.service";
import { buildUserLeadConfig } from "./configs";

export interface UserLeadResponse {
  message?: string;
  transactionId?: string;
  error?: string;
}

export async function patchUserLead(
  userId: string,
  salesforceLeadId: string,
): Promise<UserLeadResponse> {
  try {
    const { data, response } = await callApi(buildUserLeadConfig(userId, salesforceLeadId));

    if (!response.ok) {
      const message =
        typeof data === "object" && data !== null && "message" in data
          ? (data as { message?: string }).message
          : undefined;
      throw new Error(message ?? "Failed to set user lead id");
    }

    return {};
  } catch (error) {
    ClientLogsService.logError(
      userId || "unknown",
      "user-lead.service.patchUserLead",
      "Error setting user lead id",
      error instanceof Error ? error : new Error("Unknown error"),
      {
        errorType: "DependencyFailure",
        dependencyName: "UserLeadAPI",
        functionName: "patchUserLead",
      },
    );
    throw error instanceof Error ? error : new Error("Unexpected error");
  }
}
